module.exports = __webpack_public_path__ + "4d73927bf5839a35ead24113974d79c5.png";